import { gsap } from 'gsap';

export default class Circle {
    constructor(ctx, x, y, vx, vy, radius, gradient, window) {
        this.window = window;
        this.velocityDivider = gsap.utils.clamp(1, 4, Math.floor(1440 / this.window.width));
        this.radius = radius;
        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.vx = vx / this.velocityDivider;
        this.vy = vy / this.velocityDivider;
        this.gradient = gradient;
        this.allowUpdate = true;
    }

    draw() {
        this.ctx.beginPath();
        this.ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
        const gradient = this.ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.radius);
        // Add two color stops
        gradient.addColorStop(0, this.gradient.stop1);
        gradient.addColorStop(1, this.gradient.stop2);
        this.ctx.fillStyle = gradient;
        this.ctx.fill();
    }

    update() {
        if (!this.allowUpdate) {
            return;
        }

        if (this.x + this.radius > (this.window.width + this.radius) || this.x - this.radius < -this.radius) {
            this.vx = -this.vx;
        }

        if (this.y + this.radius > (this.window.height + this.radius) || this.y - this.radius < -this.radius) {
            this.vy = -this.vy;
        }

        this.x += this.vx;
        this.y += this.vy;

        this.draw();
    }
}
